import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section background="white" data-id="element-45">
      <div className="max-w-3xl mx-auto text-center border-2 border-[#5EEAD4] border-dashed rounded-3xl p-8 md:p-12 bg-[#F0FDFA]/50" data-id="element-46">
        <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-md" data-id="element-47">
          <ShieldCheck className="w-10 h-10 text-[#14B8A6]" data-id="element-48" />
        </div>

        <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#4A3B32] mb-4" data-id="element-49">
          Garantía de "Abdomen Feliz" por 30 Días
        </h2>

        <p className="text-[#5D5D5D] leading-relaxed mb-6" data-id="element-50">
          Estoy tan segura de que esta guía te ayudará a sentirte más ligera y
          cómoda, que asumo todo el riesgo. Si aplicas los consejos y no sientes
          alivio, o simplemente no te gusta el diseño de la guía, escríbeme y te
          devuelvo el 100% de tu dinero.
        </p>

        <p className="font-bold text-[#4A3B32]" data-id="element-51">
          Sin preguntas incómodas. Sin letra chica.
        </p>
      </div>
    </Section>;
}